import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import React from "react";
import ButtonBar from "../../components/Buttons/ButtonBar";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import NewButton from "../../components/Buttons/NewButton";
import UploadButton from "../../components/Buttons/UploadButton";
import { Title } from "../../components/Desc";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import { useGetResourceTypesQuery } from "../../services/appln";
import { doesPermissionExist } from "../util";
import DeleteResourceType from "./DeleteResourceType";
import EditResourceType from "./EditResourceType";
import NewResourceType from "./NewResourceType";
import UploadResourceTypes from "./UploadResourceTypes";
import BasicMenu from "../../components/menu/BasicMenu";
import { Stack } from "@mui/material";

interface ResourceType {
  id: string;
  name: string;
  desc: string;
}

export default function ListResourceTypes() {
  const resourceTypesQueryResponse = useGetResourceTypesQuery();

  const [newDialogOpen, setNewDialogOpen] = React.useState(false);
  const [uploadDialogOpen, setUploadDialogOpen] = React.useState(false);

  const columns: ColumnsType<ResourceType> = [
    {
      title: strings.name,
      dataIndex: "name",
      key: "name",
      width: 5,
    },
    {
      title: strings.desc,
      dataIndex: "desc",
      key: "desc",
      width: 10,
    },
    {
      title: "",
      dataIndex: "edit",
      key: "edit",
      width: 1,
      render: (text, record, index) =>
        doesPermissionExist("update-resource-type") && (
          <EditResourceType id={record.id} initialValues={record} />
        ),
    },
    {
      title: "",
      dataIndex: "delete",
      key: "delete",
      width: 1,
      render: (text, record, index) =>
        doesPermissionExist("delete-resource-type") && (
          <DeleteResourceType id={record.id} />
        ),
    },
  ];

  console.log(
    "ListResourceTypes, resourceTypesQueryResponse:",
    resourceTypesQueryResponse,
  );

  return (
    <Box>
      {(resourceTypesQueryResponse.isLoading ||
        resourceTypesQueryResponse.isFetching) && <ProgressIndicator />}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title text={strings.resourceTypes}></Title>
        </Grid>
        <Grid item xs={12}>
          <ButtonBar>
            <NewButton
              onClickHandler={() => {
                setNewDialogOpen(true);
              }}
            />
            <NewResourceType
              onSubmitHandler={(newObj: any) => {
                setNewDialogOpen(false);
              }}
              onCancelHandler={() => {
                setNewDialogOpen(false);
              }}
              state={newDialogOpen}
            />
            <UploadButton
              onClickHandler={() => {
                setUploadDialogOpen(true);
              }}
            />
            <UploadResourceTypes
              state={uploadDialogOpen}
              onSubmitHandler={(newObj: any) => {
                setUploadDialogOpen(false);
              }}
              onCancelHandler={() => {
                setUploadDialogOpen(false);
              }}
            />
          </ButtonBar>
        </Grid>
        <Grid item xs={12}>
          <Table
            virtual
            scroll={{ y: 600 }}
            columns={columns}
            dataSource={resourceTypesQueryResponse.data?.data}
            pagination={false}
            rowKey="id"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
